import src from "IMAGE";
export default { src, width: 1536, height: 300, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAIAAADq9gq6AAAAPUlEQVR42gEyAM3/AM3BqOvi1ezl2O3k2Lyvk4JzTXtpS2VVMwC/s5jq4dPr49fe1MSji2uFa0VoUzVYSig8vh3Sz/DrNAAAAABJRU5ErkJggg=="};
